export const fxRateColumns = () => {
  return [
    {
      id: "base_currency_code",
      accessorFn: (row) => `1 ${row.base_currency_code}`,
      header: "Base Currency",
      enableSorting: false,
    },
    {
      id: "rate",
      accessorFn: (row) => `${row.rate} ${row.target_currency_code}`,
      header: "Target Currency",
      enableSorting: false,
    },
  ];
};
